export const QueryParam = {
  Asap: 'asap',
  CompanyId: 'company_id',
  Device: 'device',
  DeviceTypeOptionsId: 'device_option_ids',
  Fulfillment: 'fulfillment',
  FullAddress: 'full_address',
  GeoLocation: 'geo_location',
  PostalCode: 'postal_code',
  Repair: 'repair',
  RepairType: 'repair_type',
  Store: 'store',
};
